import { signInWithEmailAndPassword, signOut, UserCredential } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';

import router from '@/router';
import { pluralithAuth, pluralithUsers } from '@/firebase/firebase';

const authModule = {
  state: {
    authStatus: 'none' as 'none' | 'running' | 'success' | 'failure',
    authError: ''
  },
  mutations: {
    updateAuthStatus(state: any, status: any) { state.authStatus = status },
    updateAuthError(state: any, error: any) { state.authError = error }
  },
  actions: {
    async signIn({ state, commit, dispatch }: { state: any, commit: Function, dispatch: Function }, form: any) {
      try {
        commit('updateAuthStatus', 'running')

        await signInWithEmailAndPassword(pluralithAuth, form.email, form.password)
        .catch((error: any) => {
          commit('updateAuthStatus', 'failure')
          commit('updateAuthError', error.code)
        }) as UserCredential

        if (state.authStatus !== 'failure') {
          await dispatch('getUser')
          commit('updateAuthStatus', 'success')

          if (router.currentRoute.value.query.redirect) {
            router.push({ path: '/', query: { redirect: router.currentRoute.value.query.redirect } })
          } else {
            router.push({ path: '/' })
          }
        }
      } catch(error) {
        commit('updateAuthStatus', 'failure')
        console.log('sign in error: ', error)
      }
    },

    async signOut() {
      await signOut(pluralithAuth)
      router.push({ path: '/auth' })
    },

    async getUser({ commit }: { commit: Function }) {
      if (pluralithAuth.currentUser) {
        let profileRef = doc(pluralithUsers, pluralithAuth.currentUser.uid)
        const profile = await getDoc(profileRef)
        const profileData = profile.data()
        
        if (profileData) {
          profileData['id'] = pluralithAuth.currentUser.uid
          commit('updateUser', profileData)
        }
      }
    },
  },
  getters: {}
}

export default authModule